import { HomeView } from '../../components/HomeView/homeView';

export default function Home() {
  return (
    <div>
      <HomeView></HomeView>
    </div>
  );
}